import { createElement } from 'react';

interface WeaveToggleProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  disabled?: boolean;
  toggled?: boolean;
  value?: string;
  name?: string;
  label?: string;
  id?: string;
  change?: (event: Event) => void;
}

export function WeaveToggle({
  className,
  disabled,
  toggled,
  value,
  name,
  label,
  id,
  change,
  ...rest
}: WeaveToggleProps) {
  return createElement('weave-toggle', {
    className,
    disabled,
    toggled,
    value,
    name,
    label,
    id,
    onChange: change,
    ...rest,
  });
}
